import { Delete } from 'almanac-ui/icons/16'
import { KeyboardShortcutTag } from 'common/KeyboardShortcutTag/KeyboardShortcutTag'
import { getContainerBeforePos } from 'common/Prose/utils/getContainerBeforePos'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { EditorView } from 'prosemirror-view'
import React from 'react'
import Styles from '../MoreOptionsDropdown.module.scss'

export type DeleteTextInlineFormatButtonProps = {
  view: EditorView
  callback?: () => void
}

export const DeleteTextInlineFormatButton: React.FC<React.PropsWithChildren<DeleteTextInlineFormatButtonProps>> = (
  props,
) => {
  const deleteText = () => {
    props.callback?.()
    const { state, dispatch } = props.view
    const containerFromPos = getContainerBeforePos(state.doc, state.selection.from)
    const containerToPos = getContainerBeforePos(state.doc, state.selection.to)
    const containerToAfterPos = state.doc.resolve(containerToPos.pos + (containerToPos.nodeAfter?.nodeSize || 0))

    const tr = state.tr
    tr.delete(containerFromPos.pos, containerToAfterPos.pos)

    dispatch(tr)
  }

  return (
    <InlineFormatDropdownMenuItem
      key="deleteText"
      onClick={deleteText}
      active={false}
      icon={<Delete />}
      label="Delete text"
      rightContent={
        <KeyboardShortcutTag modifiers={['Opt']} keys="D" className={Styles.shortcutKey} prefix="Del or " size="sm" />
      }
    />
  )
}
